import Link from 'next/link';
import React from 'react';
import { MENU } from '../constants';
import { usePathname } from 'next/navigation';

const HeaderMenu: React.FC<{
  isHotStyle?: boolean;
  scrolled?: boolean;
}> = ({ isHotStyle, scrolled }) => {
  const pathname = usePathname();
  const isActive = (key: string) => {
    return [key].includes(pathname);
  }

  return (
    <div className="flex items-center justify-start xl:hidden">
      {MENU.map(
        (menu) => (
          <Link
            key={menu.key}
            href={menu.link}
            aria-selected={isHotStyle && !scrolled}
            target={menu.target}
            aria-checked={isActive(menu.link)}
            className={`relative mr-6 cursor-pointer aria-checked:text-primary text-15 font-semibold aria-selected:text-white lg:mr-4 lg:text-13 `}
          >
            {menu.text}
          </Link>
        ),
      )}
    </div>
  );
};

export default HeaderMenu;
